import { useCallback, useMemo, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import AGTable from 'src/components/table/aggrid';
import EventService from 'src/services/api/eventService';
import moment from 'src/services/moment_instance';
import AssignGuestToEventModal from './AssignGuestToEventModal';
import { getAssignableFutureEvents } from './helpers';
import { PendingEventGuestsRowDef } from './PendingEventGuestsRow';

const PendingEventGuestsModal = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guests, setGuests] = useState([]);
  const [futureEvents, setFutureEvents] = useState([]);
  const [guestToAssign, setGuestToAssign] = useState(null);

  const assignableFutureEvents = useMemo(
    () => getAssignableFutureEvents(futureEvents),
    [futureEvents]
  );

  const loadData = useCallback(() => {
    setLoading(true);
    const startDate = moment.tz('America/Bogota').startOf('day').toDate();
    const endDate = moment.tz('America/Bogota').add(365, 'days').endOf('day').toDate();

    Promise.all([
      EventService.getPendingEventGuests(),
      EventService.getAuditoriumEvents({ startDate, endDate }),
    ])
      .then(([pendingRes, eventsRes]) => {
        if (pendingRes.data.success) {
          setGuests(pendingRes.data.guests || []);
        }
        if (eventsRes.data.success) {
          setFutureEvents(eventsRes.data.events || []);
        }
      })
      .catch((error) => {
        if (error.response?.data?.message) Swal.fire(error.response.data.message);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleOpen = () => {
    setOpen(true);
    loadData();
  };

  const handleAssignClick = useCallback((guestRow) => {
    setGuestToAssign(guestRow);
  }, []);

  const handleAssigned = useCallback((guestId) => {
    setGuests((prev) => prev.filter((g) => g.id !== guestId));
  }, []);

  const columnDefs = useMemo(
    () => PendingEventGuestsRowDef(handleAssignClick),
    [handleAssignClick]
  );

  return (
    <>
      <Modal
        closeIcon
        open={open}
        onClose={() => setOpen(false)}
        onOpen={handleOpen}
        trigger={<Button>Personas pendientes de asignación</Button>}
        size="large"
      >
        <Modal.Header>Personas pendientes de asignación</Modal.Header>
        <Modal.Content scrolling>
          <p style={{ marginBottom: '16px' }}>
            Invitados sacados de un evento y en espera de reasignación a cualquier servicio futuro
            disponible en la lista.
          </p>
          <Button onClick={loadData} loading={loading} style={{ marginBottom: '16px' }}>
            Refrescar
          </Button>
          {loading && !guests.length ? (
            <p>Cargando...</p>
          ) : !guests.length ? (
            <p>No hay personas pendientes de asignación.</p>
          ) : (
            <div style={{ height: '60vh', width: '100%' }}>
              <AGTable
                rowData={guests}
                columnDefs={columnDefs}
                rowHeight={80}
                defaultCol={{ autoHeight: true, suppressMovable: true }}
              />
            </div>
          )}
        </Modal.Content>
      </Modal>

      <AssignGuestToEventModal
        open={!!guestToAssign}
        guest={guestToAssign}
        assignableFutureEvents={assignableFutureEvents}
        onClose={() => setGuestToAssign(null)}
        onAssigned={handleAssigned}
      />
    </>
  );
};

export default PendingEventGuestsModal;
